import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateComponent} from "./activate/activate.component";
import {LoginComponent} from "./login/login.component";
import {LostPasswordComponent} from "./lost-password/lost-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {RegisterModalComponent} from "./register/register-modal.component";
import {PreregisterModalComponent} from "./preregister/preregister-modal.component";
import {VerifyEmailComponent} from "./verify-email/verify-email.component";
import {ChooseRegistrationComponent} from "./choose-registration/choose-registration.component";

const routes: Routes = [
    { path: 'preregister', component: PreregisterModalComponent, outlet: 'modal'},
    { path: 'verify-email', component: VerifyEmailComponent},
    { path: 'verify-email/:code', component: VerifyEmailComponent},
    { path: 'register', component: RegisterModalComponent, outlet: 'modal'},
    { path: 'login', component: LoginComponent, outlet: 'modal'},
    { path: 'lostPassword', component: LostPasswordComponent, outlet: 'modal'},
    { path: 'resetPassword', component: ResetPasswordComponent, outlet: 'modal'},
    { path: 'choose-registration', component: ChooseRegistrationComponent, outlet: 'modal'},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlatformRoutingModule { }
